<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="w"
    :height="h"
    :style="'fill:'+ s"
    :viewBox="v"
  >
    <path :d="d" />
  </svg>
</template>

<script>
export default {
  name: 'Icon',
  props: ['w', 'h', 'd', 's', 'v']
}
</script>
